import { Checkbox, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import utils from 'utils';
import styles from './SelectableButton.styles';

type Props = {
  selected?: boolean,
  onClick?: () => void
}

const SelectableButton: FC<Props> = ({
  selected = false,
  onClick
}) => {
  return (
    <Stack
      { ...utils.stack.flex.row('center', 'center') }
      spacing={ 2 }
      sx={ styles.getContainer(selected) }
      onClick={ onClick }
    >
      <Checkbox checked={ selected } color='default' />
      <Typography>{ selected ? 'Selecionado' : 'Selecionar' }</Typography>
    </Stack>
  );
};

export default SelectableButton;
